import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"

export default class extends Controller {
  async change(event) {
    const affiliateId = event.target.value
    const assessmentId = this.element.form.dataset.assessmentId
    if (!affiliateId || !assessmentId) return

    const response = await fetch(
      `/assessments/${assessmentId}/athlete-select?affiliate_id=${affiliateId}`,
      {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      }
    )

    if (response.ok) {
      renderStreamMessage(await response.text())
    } else {
      console.error("Failed to load athlete list:", response.status)
    }
  }
}

